export default __webpack_public_path__ + "static/media/AiFace.8e07944c.gif";